import {
  useGlobalCurrency,
  useGlobalPeriod,
  useReportBespoke,
  useReportContext,
  useSnapshot,
  useStructureGrouping,
} from "@iliotech/data-wire";
import React from "react";
import { useParams } from "react-router-dom";
import { ColumnChart, Toggle, ValueLegend } from "src/main";
import { useSnapshotLegendItems } from "../../__shared/useSnapshotLegendItems";
import { useGetChartData } from "./hooks/useGetChartData";
import s from "./PositionsByAbsolutePnlWidget.module.scss";
import { ReportWidgetProps } from "../../ReportWidgetProps";
export const PositionsByAbsolutePnlWidget = ({
  height,
  width,
  isHalfHeight,
  structureContext,
  periodContext,
}: ReportWidgetProps) => {
  const { portfolioId } = useParams();
  const [hideClosedPositions, setHideClosedPositions] = React.useState(false);
  const { periodString } = periodContext;
  const { currencyFormatter } = useGlobalCurrency();
  const snapshots = useSnapshot(portfolioId!);
  const { grouping, selectedGroup, setSelectedGroup } =
    structureContext || useStructureGrouping();
  const { getChartData } = useGetChartData({
    portfolioId: portfolioId!,
    grouping,
    selectedGroup,
  });
  const { getLegendItems } = useSnapshotLegendItems({
    grouping,
    selectedGroup,
    setSelectedGroup,
    currencyFormatter,
    snapshots: snapshots?.data?.data ?? [],
    t: () => "",
  });
  const allPositionLegendItems = getLegendItems(false);
  const { columnChartData } = getChartData(hideClosedPositions);
  const store = useReportBespoke();
  const generating = store.generating;
  const openPositionLegendItems = hideClosedPositions
    ? getLegendItems(true)
    : allPositionLegendItems;

  const renderColumnChart = React.useMemo(
    () => (
      <ColumnChart
        generating={generating}
        valueFormatter={currencyFormatter}
        maxBars={10}
        height={height}
        data={columnChartData}
        hideLegend
        valueLabel={"P&L"}
        passedWidth={width}
        maxCategoryLabelLength={8}
      />
    ),
    [currencyFormatter, columnChartData, generating, height, width]
  );

  return (
    <div>
      <div className="keep-together">
        <div className={s.row}>
          <h4 className={"element-title"}>{"Positions absolute P&L"}</h4>
          <Toggle
            left={"Show closed positions"}
            right={"Hide closed positions"}
            onClick={(val) => setHideClosedPositions(val === 1)}
          />
        </div>
        <p className={"period-string"}>{periodString}</p>
        {renderColumnChart}
        <ValueLegend small={isHalfHeight} items={openPositionLegendItems} />
      </div>
    </div>
  );
};
